import React from 'react';
export function FAQ() {
  const faqs = [{
    q: '¿Es legal hacer esto yo mismo?',
    a: '100% legal. La ley FCRA se creó para que los consumidores se defiendan de los abusos de los burós.'
  }, {
    q: '¿Necesito un abogado?',
    a: 'No. El proceso está diseñado para que cualquier persona que sepa seguir instrucciones básicas pueda ejecutarlo.'
  }, {
    q: '¿Sirve si tengo ITIN?',
    a: 'Sí, las leyes de reporte de crédito aplican de la misma forma para SSN que para ITIN.'
  }, {
    q: '¿Cuánto tiempo tengo acceso a la guía?',
    a: 'Es tuya para siempre. Puedes descargarla y consultarla cada vez que lo necesites.'
  }];
  return <section className="bg-navy-900 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-15">
      <div className="mx-auto max-w-3xl" data-id="element-16">
        <h2 className="mb-12 text-center text-4xl sm:text-5xl font-bebas text-white" data-id="element-17">
          Preguntas <span className="text-gold-400" data-id="element-18">Frecuentes</span>
        </h2>

        <div className="space-y-6" data-id="element-19">
          {faqs.map((faq, index) => <div key={index} className="rounded-xl bg-navy-800 p-6 border border-slate-700/50" data-id="element-20">
              <h3 className="mb-3 text-xl font-bold text-white" data-id="element-21">{faq.q}</h3>
              <p className="text-slate-300" data-id="element-22">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}